import React from "react";
import {FormFieldInput} from "ui-components-rollup/dist/Forms";
import FormFieldSelect from "../../../../../components/widgets/FormFieldSelect";
import awsRegions from "../../../utils/awsRegionList";
import styles from "./Form.module.scss";

export default ({ onFormSubmit, handleFormSubmit, handleFormChange, formState, formErrors, submissionAttempted }) => {
    return (
        <form className={styles["form"]} onSubmit={handleFormSubmit(onFormSubmit)}>
            <FormFieldInput
                type="text"
                name="name"
                label="Working Environment Name"
                value={formState.name}
                onChange={handleFormChange}
                charCount={true}
                maxChars={256}
                errorMessage={submissionAttempted && formErrors.name}
            />
            <FormFieldInput
                type="text"
                name="apiKey"
                label="Cloud Volumes Service API Key"
                value={formState.apiKey}
                onChange={handleFormChange}
                errorMessage={submissionAttempted && formErrors.apiKey}
            />
            <FormFieldInput
                type="password"
                name="secretKey"
                label="Cloud Volumes Service Secret Key"
                value={formState.secretKey}
                onChange={handleFormChange}
                errorMessage={submissionAttempted && formErrors.secretKey}
            />
            <FormFieldSelect
                isCreatable={false}
                name="region"
                label="AWS Region"
                placeholder="- Please Select -"
                onChange={handleFormChange}
                isClearable={true}
                isSearchable={true}
                isMulti={false}
                options={awsRegions}
                value={formState.region}
                errorMessage={submissionAttempted && formErrors.region}
                // isDisabled={serviceName === "all"}
            />
        </form>
    );
};
